const DEPART_CITY_DIC = {
  1: {
    name: 'Москва',
    name_from: 'Москвы',
    url: 'moskva',
    sletat_id: 832,
    country__name: 'Курорты России',
    id: 1,
    country_id: 47,
    country_url: 'rossiia',
  },
  2: {
    name: 'Пермь',
    name_from: 'Перми',
    url: 'perm',
    sletat_id: 1276,
    country__name: 'Курорты России',
    id: 2,
    country_id: 47,
    country_url: 'rossiia',
  },
  3: {
    name: 'Екатеринбург',
    name_from: 'Екатеринбурга',
    url: 'ekaterinburg',
    sletat_id: 1265,
    country__name: 'Курорты России',
    id: 3,
    country_id: 47,
    country_url: 'rossiia',
  },
  4: {
    name: 'Уфа',
    name_from: 'Уфы',
    url: 'ufa',
    sletat_id: 1274,
    country__name: 'Курорты России',
    id: 4,
    country_id: 47,
    country_url: 'rossiia',
  },
  5: {
    name: 'Санкт-Петербург',
    name_from: 'Санкт-Петербурга',
    url: 'sankt-peterburg',
    sletat_id: 1264,
    country__name: 'Курорты России',
    id: 5,
    country_id: 47,
    country_url: 'rossiia',
  },
  6: {
    name: 'Челябинск',
    name_from: 'Челябинска',
    url: 'cheliabinsk',
    sletat_id: 1272,
    country__name: 'Курорты России',
    id: 6,
    country_id: 47,
    country_url: 'rossiia',
  },
  7: {
    name: 'Самара',
    name_from: 'Самары',
    url: 'samara',
    sletat_id: 1271,
    country__name: 'Курорты России',
    id: 7,
    country_id: 47,
    country_url: 'rossiia',
  },
  8: {
    name: 'Нижний Новгород',
    name_from: 'Нижнего Новгорода',
    url: 'nizhnii-novgorod',
    sletat_id: 1268,
    country__name: 'Курорты России',
    id: 8,
    country_id: 47,
    country_url: 'rossiia',
  },
  9: {
    name: 'Новосибирск',
    name_from: 'Новосибирска',
    url: 'novosibirsk',
    sletat_id: 1267,
    country__name: 'Курорты России',
    id: 9,
    country_id: 47,
    country_url: 'rossiia',
  },
  10: {
    name: 'Казань',
    name_from: 'Казани',
    url: 'kazan',
    sletat_id: 1266,
    country__name: 'Курорты России',
    id: 10,
    country_id: 47,
    country_url: 'rossiia',
  },
  11: {
    name: 'Краснодар',
    name_from: 'Краснодара',
    url: 'krasnodar',
    sletat_id: 1270,
    country__name: 'Курорты России',
    id: 11,
    country_id: 47,
    country_url: 'rossiia',
  },
  12: {
    name: 'Красноярск',
    name_from: 'Красноярска',
    url: 'krasnoiarsk',
    sletat_id: 1281,
    country__name: 'Курорты России',
    id: 12,
    country_id: 47,
    country_url: 'rossiia',
  },
  13: {
    name: 'Сургут',
    name_from: 'Сургута',
    url: 'surgut',
    sletat_id: 1294,
    country__name: 'Курорты России',
    id: 13,
    country_id: 47,
    country_url: 'rossiia',
  },
  14: {
    name: 'Тюмень',
    name_from: 'Тюмени',
    url: 'tiumen',
    sletat_id: 1273,
    country__name: 'Курорты России',
    id: 14,
    country_id: 47,
    country_url: 'rossiia',
  },
  15: {
    name: 'Кемерово',
    name_from: 'Кемерово',
    url: 'kemerovo',
    sletat_id: 1282,
    country__name: 'Курорты России',
    id: 15,
    country_id: 47,
    country_url: 'rossiia',
  },
  16: {
    name: 'Новокузнецк',
    name_from: 'Новокузнецка',
    url: 'novokuznetsk',
    sletat_id: 1341,
    country__name: 'Курорты России',
    id: 16,
    country_id: 47,
    country_url: 'rossiia',
  },
  17: {
    name: 'Калининград',
    name_from: 'Калининграда',
    url: 'kaliningrad',
    sletat_id: 1280,
    country__name: 'Курорты России',
    id: 17,
    country_id: 47,
    country_url: 'rossiia',
  },
  18: {
    name: 'Ростов-на-Дону',
    name_from: 'Ростова-на-Дону',
    url: 'rostov-na-donu',
    sletat_id: 1269,
    country__name: 'Курорты России',
    id: 18,
    country_id: 47,
    country_url: 'rossiia',
  },
  19: {
    name: 'Нижнекамск',
    name_from: 'Нижнекамска',
    url: 'nizhnekamsk',
    sletat_id: null,
    country__name: 'Курорты России',
    id: 19,
    country_id: 47,
    country_url: 'rossiia',
  },
  20: {
    name: 'Хабаровск',
    name_from: 'Хабаровска',
    url: 'khabarovsk',
    sletat_id: 1286,
    country__name: 'Курорты России',
    id: 20,
    country_id: 47,
    country_url: 'rossiia',
  },
  21: {
    name: 'Омск',
    name_from: 'Омска',
    url: 'omsk',
    sletat_id: 1278,
    country__name: 'Курорты России',
    id: 21,
    country_id: 47,
    country_url: 'rossiia',
  },
  22: {
    name: 'Иркутск',
    name_from: 'Иркутска',
    url: 'irkutsk',
    sletat_id: 1285,
    country__name: 'Курорты России',
    id: 22,
    country_id: 47,
    country_url: 'rossiia',
  },
  23: {
    name: 'Владивосток',
    name_from: 'Владивостока',
    url: 'vladivostok',
    sletat_id: 1293,
    country__name: 'Курорты России',
    id: 23,
    country_id: 47,
    country_url: 'rossiia',
  },
  24: {
    name: 'Южно-Сахалинск',
    name_from: 'Южно-Сахалинска',
    url: 'iuzhno-sakhalinsk',
    sletat_id: 1307,
    country__name: 'Курорты России',
    id: 24,
    country_id: 47,
    country_url: 'rossiia',
  },
  25: {
    name: 'Барнаул',
    name_from: 'Барнаула',
    url: 'barnaul',
    sletat_id: 1305,
    country__name: 'Курорты России',
    id: 25,
    country_id: 47,
    country_url: 'rossiia',
  },
  26: {
    name: 'Воронеж',
    name_from: 'Воронежа',
    url: 'voronezh',
    sletat_id: 1283,
    country__name: 'Курорты России',
    id: 26,
    country_id: 47,
    country_url: 'rossiia',
  },
  27: {
    name: 'Волгоград',
    name_from: 'Волгограда',
    url: 'volgograd',
    sletat_id: 1279,
    country__name: 'Курорты России',
    id: 27,
    country_id: 47,
    country_url: 'rossiia',
  },
  28: {
    name: 'Оренбург',
    name_from: 'Оренбурга',
    url: 'orenburg',
    sletat_id: 1290,
    country__name: 'Курорты России',
    id: 28,
    country_id: 47,
    country_url: 'rossiia',
  },
  29: {
    name: 'Архангельск',
    name_from: 'Архангельска',
    url: 'arkhangelsk',
    sletat_id: 1275,
    country__name: 'Курорты России',
    id: 29,
    country_id: 47,
    country_url: 'rossiia',
  },
  30: {
    name: 'Мурманск',
    name_from: 'Мурманска',
    url: 'murmansk',
    sletat_id: 1284,
    country__name: 'Курорты России',
    id: 30,
    country_id: 47,
    country_url: 'rossiia',
  },
  31: {
    name: 'Саратов',
    name_from: 'Саратова',
    url: 'saratov',
    sletat_id: 1300,
    country__name: 'Курорты России',
    id: 31,
    country_id: 47,
    country_url: 'rossiia',
  },
  32: {
    name: 'Белгород',
    name_from: 'Белгорода',
    url: 'belgorod',
    sletat_id: 1306,
    country__name: 'Курорты России',
    id: 32,
    country_id: 47,
    country_url: 'rossiia',
  },
  34: {
    name: 'Нижневартовск',
    name_from: 'Нижневартовска',
    url: 'nizhnevartovsk',
    sletat_id: 1298,
    country__name: 'Курорты России',
    id: 34,
    country_id: 47,
    country_url: 'rossiia',
  },
  35: {
    name: 'Ханты-Мансийск',
    name_from: 'Ханты-Мансийска',
    url: 'khanty-mansiisk',
    sletat_id: 1297,
    country__name: 'Курорты России',
    id: 35,
    country_id: 47,
    country_url: 'rossiia',
  },
  36: {
    name: 'Благовещенск',
    name_from: 'Благовещенска',
    url: 'blagoveshchensk',
    sletat_id: 1331,
    country__name: 'Курорты России',
    id: 36,
    country_id: 47,
    country_url: 'rossiia',
  },
  37: {
    name: 'Якутск',
    name_from: 'Якутска',
    url: 'iakutsk',
    sletat_id: 1332,
    country__name: 'Курорты России',
    id: 37,
    country_id: 47,
    country_url: 'rossiia',
  },
  38: {
    name: 'Брянск',
    name_from: 'Брянска',
    url: 'briansk',
    sletat_id: null,
    country__name: 'Курорты России',
    id: 38,
    country_id: 47,
    country_url: 'rossiia',
  },
  39: {
    name: 'Минеральные Воды',
    name_from: 'Минеральных Вод',
    url: 'mineralnye-vody',
    sletat_id: 1299,
    country__name: 'Курорты России',
    id: 39,
    country_id: 47,
    country_url: 'rossiia',
  },
  40: {
    name: 'Астрахань',
    name_from: 'Астрахани',
    url: 'astrakhan',
    sletat_id: 1292,
    country__name: 'Курорты России',
    id: 40,
    country_id: 47,
    country_url: 'rossiia',
  },
  41: {
    name: 'Сыктывкар',
    name_from: 'Сыктывкара',
    url: 'syktyvkar',
    sletat_id: 1296,
    country__name: 'Курорты России',
    id: 41,
    country_id: 47,
    country_url: 'rossiia',
  },
  44: {
    name: 'Чита',
    name_from: 'Читы',
    url: 'chita',
    sletat_id: null,
    country__name: 'Курорты России',
    id: 44,
    country_id: 47,
    country_url: 'rossiia',
  },
  46: {
    name: 'Владикавказ',
    name_from: 'Владикавказа',
    url: 'vladikavkaz',
    sletat_id: null,
    country__name: 'Курорты России',
    id: 46,
    country_id: 47,
    country_url: 'rossiia',
  },
  48: {
    name: 'Магнитогорск',
    name_from: 'Магнитогорска',
    url: 'magnitogorsk',
    sletat_id: 1288,
    country__name: 'Курорты России',
    id: 48,
    country_id: 47,
    country_url: 'rossiia',
  },
  50: {
    name: 'Ульяновск',
    name_from: 'Ульяновска',
    url: 'ulianovsk',
    sletat_id: 1295,
    country__name: 'Курорты России',
    id: 50,
    country_id: 47,
    country_url: 'rossiia',
  },
  52: {
    name: 'Томск',
    name_from: 'Томска',
    url: 'tomsk',
    sletat_id: 1301,
    country__name: 'Курорты России',
    id: 52,
    country_id: 47,
    country_url: 'rossiia',
  },
  55: {
    name: 'Ставрополь',
    name_from: 'Ставрополя',
    url: 'stavropol',
    sletat_id: 1355,
    country__name: 'Курорты России',
    id: 55,
    country_id: 47,
    country_url: 'rossiia',
  },
  56: {
    name: 'Сочи',
    name_from: 'Сочи',
    url: 'sochi',
    sletat_id: 1291,
    country__name: 'Курорты России',
    id: 56,
    country_id: 47,
    country_url: 'rossiia',
  },
  57: {
    name: 'Минск',
    name_from: 'Минска',
    url: 'minsk',
    sletat_id: 1308,
    country__name: 'Беларусь',
    id: 57,
    country_id: 57,
    country_url: 'belarus',
  },
  58: {
    name: 'Киев',
    name_from: 'Киева',
    url: 'kiev',
    sletat_id: 1311,
    country__name: 'Украина',
    id: 58,
    country_id: null,
    country_url: 'ukraina',
  },
  59: {
    name: 'Астана',
    name_from: 'Астаны',
    url: 'nur-sultan-astana',
    sletat_id: 1323,
    country__name: 'Казахстан',
    id: 59,
    country_id: 78,
    country_url: 'kazakhstan',
  },
  60: {
    name: 'Алматы',
    name_from: 'Алматы',
    url: 'almaty',
    sletat_id: 1312,
    country__name: 'Казахстан',
    id: 60,
    country_id: 78,
    country_url: 'kazakhstan',
  },
  62: {
    name: 'Симферополь',
    name_from: 'Симферополя',
    url: 'simferopol',
    sletat_id: 1326,
    country__name: 'Курорты России',
    id: 62,
    country_id: 47,
    country_url: 'rossiia',
  },
  63: {
    name: 'Анапа',
    name_from: 'Анапы',
    url: 'anapa',
    sletat_id: 1372,
    country__name: 'Курорты России',
    id: 63,
    country_id: 47,
    country_url: 'rossiia',
  },
  68: {
    name: 'Костанай',
    name_from: 'Костаная',
    url: 'kostanai',
    sletat_id: 1345,
    country__name: 'Казахстан',
    id: 68,
    country_id: 78,
    country_url: 'kazakhstan',
  },
  69: {
    name: 'Гомель',
    name_from: 'Гомеля',
    url: 'gomel',
    sletat_id: 1366,
    country__name: 'Беларусь',
    id: 69,
    country_id: 57,
    country_url: 'belarus',
  },
  70: {
    name: 'Брест',
    name_from: 'Бреста',
    url: 'brest',
    sletat_id: 1321,
    country__name: 'Беларусь',
    id: 70,
    country_id: 57,
    country_url: 'belarus',
  },
  71: {
    name: 'Витебск',
    name_from: 'Витебска',
    url: 'vitebsk',
    sletat_id: 1364,
    country__name: 'Беларусь',
    id: 71,
    country_id: 57,
    country_url: 'belarus',
  },
  73: {
    name: 'Актобе',
    name_from: 'Актобе',
    url: 'aktobe',
    sletat_id: 1342,
    country__name: 'Казахстан',
    id: 73,
    country_id: 78,
    country_url: 'kazakhstan',
  },
  74: {
    name: 'Актау',
    name_from: 'Актау',
    url: 'aktau',
    sletat_id: 1347,
    country__name: 'Казахстан',
    id: 74,
    country_id: 78,
    country_url: 'kazakhstan',
  },
  75: {
    name: 'Атырау',
    name_from: 'Атырау',
    url: 'atyrau',
    sletat_id: null,
    country__name: 'Казахстан',
    id: 75,
    country_id: 78,
    country_url: 'kazakhstan',
  },
  76: {
    name: 'Караганда',
    name_from: 'Караганды',
    url: 'karaganda',
    sletat_id: 1343,
    country__name: 'Казахстан',
    id: 76,
    country_id: 78,
    country_url: 'kazakhstan',
  },
  78: {
    name: 'Усть-Каменогорск',
    name_from: 'Усть-Каменогорска',
    url: 'ust-kamenogorsk',
    sletat_id: null,
    country__name: 'Казахстан',
    id: 78,
    country_id: 78,
    country_url: 'kazakhstan',
  },
  79: {
    name: 'Шымкент',
    name_from: 'Шымкента',
    url: 'shymkent',
    sletat_id: 1349,
    country__name: 'Казахстан',
    id: 79,
    country_id: 78,
    country_url: 'kazakhstan',
  },
  80: {
    name: 'Бишкек',
    name_from: 'Бишкека',
    url: 'bishkek',
    sletat_id: 1351,
    country__name: 'Киргизия',
    id: 80,
    country_id: 60,
    country_url: 'kyrgyzctan',
  },
  82: {
    name: 'Могилев',
    name_from: 'Могилева',
    url: 'mogilev',
    sletat_id: 1367,
    country__name: 'Беларусь',
    id: 82,
    country_id: 57,
    country_url: 'belarus',
  },
  83: {
    name: 'Гродно',
    name_from: 'Гродно',
    url: 'grodno',
    sletat_id: null,
    country__name: 'Беларусь',
    id: 83,
    country_id: 57,
    country_url: 'belarus',
  },
  84: {
    name: 'Уральск',
    name_from: 'Уральска',
    url: 'uralsk',
    sletat_id: 1350,
    country__name: 'Казахстан',
    id: 84,
    country_id: 78,
    country_url: 'kazakhstan',
  },
  85: {
    name: 'Ярославль',
    name_from: 'Ярославля',
    url: 'yaroslavl',
    sletat_id: null,
    country__name: 'Курорты России',
    id: 85,
    country_id: 47,
    country_url: 'rossiia',
  },
  94: {
    name: 'Махачкала',
    name_from: 'Махачкалы',
    url: 'mahachkaly',
    sletat_id: null,
    country__name: 'Курорты России',
    id: 94,
    country_id: 47,
    country_url: 'rossiia',
  },
  95: {
    name: 'Калуга',
    name_from: 'Калуги',
    url: 'kaluga',
    sletat_id: null,
    country__name: 'Курорты России',
    id: 95,
    country_id: 47,
    country_url: 'rossiia',
  },
  96: {
    name: 'Грозный',
    name_from: 'Грозного',
    url: 'groznyi',
    sletat_id: 1376,
    country__name: 'Курорты России',
    id: 96,
    country_id: 47,
    country_url: 'rossiia',
  },
  97: {
    name: 'Тараз',
    name_from: 'Тараза',
    url: 'taraz',
    sletat_id: null,
    country__name: 'Казахстан',
    id: 97,
    country_id: 78,
    country_url: 'kazakhstan',
  },
  98: {
    name: 'Петропавловск',
    name_from: 'Петропавловска',
    url: 'petropavlovsk',
    sletat_id: null,
    country__name: 'Казахстан',
    id: 98,
    country_id: 78,
    country_url: 'kazakhstan',
  },
  99: {
    name: 'Без перелета',
    name_from: 'Без перелета',
    url: 'no-flight',
    sletat_id: null,
    country__name: 'Курорты России',
    id: 99,
    country_id: 47,
    country_url: 'rossiia',
  },
  101: {
    name: 'Саранск',
    name_from: 'Саранска',
    url: 'saransk',
    sletat_id: null,
    country__name: 'Курорты России',
    id: 101,
    country_id: 47,
    country_url: 'rossiia',
  },
  103: {
    name: 'Иваново',
    name_from: 'Иваново',
    url: 'ivanovo',
    sletat_id: null,
    country__name: 'Курорты России',
    id: 103,
    country_id: 47,
    country_url: 'rossiia',
  },
  115: {
    name: 'Липецк',
    name_from: 'Липецка',
    url: 'lipetsk',
    sletat_id: 1354,
    country__name: 'Курорты России',
    id: 115,
    country_id: 47,
    country_url: 'rossiia',
  },
  121: {
    name: 'Семей',
    name_from: 'Семея',
    url: 'semej',
    sletat_id: null,
    country__name: 'Казахстан',
    id: 121,
    country_id: 78,
    country_url: 'kazakhstan',
  },
};

export default DEPART_CITY_DIC;
